import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import GetInTouch from '../Components/Contact/GetInTouch'
import BookATour from '../Components/Contact/BookATour'
import ContactMap from '../Components/Contact/ContactMap'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import { useSiteContent, sectionField } from '../hooks/useSiteContent'
import { usePageBanner } from '../hooks/usePageBanner'
import { getImageUrl } from '../utils/imageUrl'

function Contact() {
    const { content } = useSiteContent('contact')
    const fallbackTitle = sectionField(content, 'breadcrumb', 'title', 'Contact Us')
    const contentBanner = getImageUrl(sectionField(content, 'breadcrumb', 'banner_image', ''))
    const { title, bgImage } = usePageBanner({
        pageSlug: 'contact',
        fallbackTitle,
        fallbackImage: contentBanner,
    })

    return (
        <>
            <HeaderOne />
            <Breadcrumb title={title} bgImage={bgImage} />
            <GetInTouch />
            <BookATour />
            <ContactMap />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default Contact
